/** @module general */

/**
 *  Funktionalität zur Umschaltung der Sprachauswahl
 */
export class OpaccLanguage {
	constructor() {
		this.wrapperElement = document.querySelector('body');
		this.languageSelector = '.opc-language-selection[data-op-layout="list"]';
		this.languageElement = this.wrapperElement.querySelectorAll(this.languageSelector);

		this.attachEventListener();
	}

	/**
	 * Event Registrierung im DOM
	 */
	attachEventListener() {
		if (this.languageElement.length > 0) {
			this.wrapperElement.addEventListener('click', e => {
				let currentLanguageElement = e.target.closest(this.languageSelector);
				if (currentLanguageElement) {
					this.toggleLanguageElement(currentLanguageElement);
				} else if (e.target.closest(this.languageSelector) === null) {
					Array.from(this.languageElement).forEach(item => {
						if (item.classList.contains('is-open')) {
							this.toggleLanguageElement(item);
						}
					});
				}
			});
		}
	}

	/**
	 * Sichtbarkeit (offen oder geschlossen) der Sprachauswahl umschalten
	 *
	 * @param {HTMLElement} languageElement Element, welches Umgeschaltet (öffnen / schliessen) werden soll
	 */
	toggleLanguageElement(languageElement) {
		languageElement.classList.toggle('is-open');
	}
}